var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"confetti"},_vm._l((100),function(num){return _c('div',{key:("confetti_index_" + num),class:("confetti__item--" + num)})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }